const emailVerificationConstants = {
  pollIntervalMs: 4000,
  resendCooldownSeconds: 60,
  oneSecondMs: 1000,
  verifiedRedirectPath: '/welcome/redirect',
  loginPath: '/login',
  logoutPath: '/logout',
  unlinkedLogoHref: '#',
  pathsAvailableWhilePending: [
    '/verifyEmail',
    '/logout',
    '/sign-up',
    '/sign-up/subscription-types/[subscriptionTypeId]',
    '/sign-up/success',
  ],
};

export default emailVerificationConstants;
